import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { Row, Card, CardBody, CardHeader, Col } from 'reactstrap';
import { APIClient } from '../../../../helpers/api_helper';

export const DashboardProposalsByPlanChart = ({ isShow, office }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const api = new APIClient();

  const series = [
    {
      data: data,
    },
  ];

  const options = {
    plotOptions: {
      bar: {
        borderRadius: 4,
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    chart: {
      toolbar: {
        show: false,
      },
    },
    colors: ['#405189'],
    tooltip: {
      enabled: true,
      style: {
        fontSize: '12px',
        fontFamily: undefined,
      },
      onDatasetHover: {
        highlightDataSeries: false,
      },
      marker: {
        show: true,
      },
      y: {
        formatter: function (value) {
          return value;
        },
        title: {
          formatter: () => 'N° de Propostas',
        },
      },
      fixed: {
        enabled: false,
        position: 'topRight',
        offsetX: 0,
        offsetY: 0,
      },
    },
  };

  const ProposalsByPlanChart = () => {
    return (
      <Card>
        <CardHeader className="border-0 align-items-center d-flex">
          <h4 className="card-title mb-0 flex-grow-1">Propostas por Planos</h4>
        </CardHeader>
        <CardBody className="p-0">
          <Chart
            type="bar"
            height={475}
            series={series}
            options={options}
            className="apex-charts"
          />
        </CardBody>
      </Card>
    );
  };

  const getByPlans = async (office) => {
    await api
      .get(`/overview/proposals-by-plans?office=${office}`)
      .then((res) => {
        setData(res);
        setLoading(false);
      });
  };

  useEffect(() => {
    getByPlans(office);
  }, [office]);

  return loading ? (
    <Col xs={12} md={6} lg={6}>
      <Card>
        <SkeletonTheme baseColor="#8B919F">
          <Row className="p-1">
            <div className="text-center">
              <Skeleton height={515} />
            </div>
          </Row>
        </SkeletonTheme>
      </Card>
    </Col>
  ) : isShow ? (
    <Col xs={12} md={6} lg={6}>
      <ProposalsByPlanChart />
    </Col>
  ) : null;
};
